// ============================================================================
// TOP > バナースライダー
// ============================================================================
// window.addEventListener("load", function () {
//     const sliderSwiper = new Swiper(".p-top-slider__swiper", {
//         loop: true,
//         centeredSlides: true,
//         spaceBetween: 0,
//         slidesPerView: 1,
//         speed: 1000,
//         autoplay: {
//             delay: 5000,
//         },
//         pagination: {
//             el: '.swiper-pagination',
//             clickable: true,
//         },
//         navigation: {
//             nextEl: '.swiper-button-next',
//             prevEl: '.swiper-button-prev',
//         },
//         breakpoints: {
//             749: {
//                 slidesPerView: 1.2,
//                 spaceBetween: 20,
//             },
//             1025: {
//                 slidesPerView: 1.94,
//                 spaceBetween: 20,
//             }
//         }
//     });
// });

document.addEventListener("DOMContentLoaded", function () {
  function topBannerSlider(){
    setTimeout(function () {
        const sliderSwiper = new Swiper(".p-top-slider__swiper", {
        loop: true,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 1000,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            749: {
                slidesPerView: 1.2,
                spaceBetween: 20,
            },
            1025: {
                slidesPerView: 1.94,
                spaceBetween: 20,
            }
        }
    });
    }, 300);
  }
  topBannerSlider();
  document.addEventListener("shopify:section:load", function () {
      topBannerSlider();
  });
});


